import React from 'react';
import { Card } from 'shared-portal-components-v2';

import { classNames } from '@/utils/classNames.utils';

interface SixDetailActivityCardProps {
  title: string;
  actorLabel: string;
  timestampLabel: string;
  badgeLabel: string;
  className?: string;
}

export default function SixDetailActivityCard({
  title,
  actorLabel,
  timestampLabel,
  badgeLabel,
  className,
}: SixDetailActivityCardProps) {
  return (
    <Card
      className={classNames(
        'rounded-lg border bg-card text-card-foreground shadow-sm hover:shadow-sm transition-shadow',
        className
      )}
    >
      <div className="p-3 sm:p-4">
        <div className="flex flex-col sm:flex-row sm:items-start space-y-2 sm:space-y-0 sm:space-x-3">
          <div className="flex-1 min-w-0 space-y-1">
            <p className="text-sm font-medium text-foreground">{title}</p>

            <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2 space-y-1 sm:space-y-0">
              <p className="text-xs text-muted-foreground">{actorLabel}</p>
              <span className="text-xs text-muted-foreground hidden sm:inline">•</span>
              <p className="text-xs text-muted-foreground">{timestampLabel}</p>
            </div>
          </div>

          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground text-xs flex-shrink-0 self-start">
            {badgeLabel}
          </div>
        </div>
      </div>
    </Card>
  );
}
